import React, { useEffect } from "react";
import { OneTileDynamicZoneModel } from "@models/strapi-components/tile-wrapper";
import useIcons from "@hooks/use-source-icons";
import Title from "@components/common/Title";
import { useMeasure } from "@uidotdev/usehooks";
import { motion } from "framer-motion";

export interface TreeTileProps {
  tile: OneTileDynamicZoneModel;
  handlePostRenderHeightSetting: (height: number) => void;
  key?: string | number;
}

const TreeTile: React.FunctionComponent<TreeTileProps> = ({
  tile,
  handlePostRenderHeightSetting,
}) => {
  const { icon, subTitle, color } = tile;
  const { getFromReactIcons } = useIcons();
  const Icon = getFromReactIcons(icon);
  const [ref, { height }] = useMeasure();

  useEffect(() => {
    if (height && height > 0) {
      handlePostRenderHeightSetting(height);
    }
  }, [height]);

  return (
    <motion.div
      key={tile.id}
      className="flex justify-center text-black h-40 xl:h-auto mb-16 xl:mb-0 last:mb-0"
      ref={ref}
    >
      <div
        className="rounded-lg max-w-[300px] flex items-center justify-center p-5 xl:py-[50px] xl:px-[40px] text-center font-medium relative"
        style={{ backgroundColor: color }}
      >
        <div
          className="absolute h-16 w-16 border-[3px] rounded-full -top-8 flex items-center justify-center shadow-md border-white"
          style={{
            backgroundColor: tile.color,
          }}
        >
          {Icon && <Icon size={36} />}
        </div>
        <Title variant="paragraph" titleText={subTitle} />
      </div>
    </motion.div>
  );
};

export default TreeTile;
